import { isPlatformBrowser } from '@angular/common';
import {
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApplicationConfig } from '../config/config';
import { Tooltip } from '../model/content/contentTooltip.model';
import { CommonService } from '../services/common.service';
import { CabinExperiencesComponent } from './cabin-experiences/cabin-experiences.component';
import { CheckinConfirmationNoComponent } from './checkin-confirmation-no/checkin-confirmation-no.component';
import { CheckinTicketNoComponent } from './checkin-ticket-no/checkin-ticket-no.component';
import { ConnectionComponent } from './connection/connection.component';
import { MeetingCodeComponent } from './meeting-code/meeting-code.component';
import { MyTripsConfirmationNoComponent } from './mytrips-confirmation-no/mytrips-confirmation-no.component';
import { MyTripsTicketNoComponent } from './mytrips-ticket-no/mytrips-ticket-no.component';
import { RefundableFlightsComponent } from './refundable-flights/refundable-flights.component';
import { ShowPriceInComponent } from './show-price-in/show-price-in.component';
import { YoungAdultPaxComponent } from './young-adult-pax/young-adult-pax.component';

@Directive({
  selector: '[ngc-help-modal-directive]',
  exportAs: 'ngcHelpModalDirective'
})
export class HelpModalDirective {
  @Input() type;
  @Input() helpContent: Tooltip;
  triggerElement;

  bsModalRef: BsModalRef;
  config = {
    animated: false
  };

  constructor(
    private modalService: BsModalService,
    private el: ElementRef,
    private ren: Renderer2,
    private srv: CommonService,
    private appconfig: ApplicationConfig,
    private loggingService: LoggingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.triggerElement = el.nativeElement;
  }

  openHelpModal() {
    const bodyScroll = document.documentElement.scrollTop;
    let obj = Object.assign({}, this.config, { class: 'help' });

    if (this.type === 'connection') {
      this.bsModalRef = this.modalService.show(ConnectionComponent, obj);
    } else if (this.type === 'mytripsconfno') {
      this.bsModalRef = this.modalService.show(
        MyTripsConfirmationNoComponent,
        obj
      );
    } else if (this.type === 'checkinconfno') {
      this.bsModalRef = this.modalService.show(
        CheckinConfirmationNoComponent,
        obj
      );
    } else if (this.type === 'checkinticketno') {
      this.bsModalRef = this.modalService.show(CheckinTicketNoComponent, obj);
    } else if (this.type === 'mytripsticketno') {
      this.bsModalRef = this.modalService.show(MyTripsTicketNoComponent, obj);
    } else if (this.type === 'refundablefares') {
      obj = Object.assign({}, this.config, { class: 'help' });
      this.bsModalRef = this.modalService.show(RefundableFlightsComponent, obj);
    } else if (this.type === 'showpricein') {
      this.bsModalRef = this.modalService.show(ShowPriceInComponent, obj);
    } else if (this.type === 'meetingCode') {
      this.bsModalRef = this.modalService.show(MeetingCodeComponent, obj);
    } else if (this.type === 'cabinExperiences') {
      this.bsModalRef = this.modalService.show(CabinExperiencesComponent, obj);
    } else if (this.type === 'youngadultpax') {
      this.bsModalRef = this.modalService.show(YoungAdultPaxComponent, obj);
    }
    if (this.bsModalRef) {
      this.bsModalRef.content.tooltipContent = this.helpContent;
    }
    const htmlRoot = document.getElementsByTagName('html')[0];
    if (!(htmlRoot.className.indexOf('no-scroll') >= 0)) {
      htmlRoot.className += ' no-scroll';
    }
    if (this.appconfig.get('APP_DISABLE_LEGACY') === 'false') {
      if (isPlatformBrowser(this.platformId) && document && window) {
        const width = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        if (width < 992) {
          this.ren.addClass(
            document.getElementsByTagName('modal-container')[0],
            'fresh-air'
          );
        } else {
          this.srv.dragModalContainers(this.el, this.ren);
          document.documentElement.scrollTop = bodyScroll;
          this.srv.focusModalContainers(this.el, this.ren);
        }
      }
    }
    this.bsModalRef.content.helpDialog.nativeElement.focus();
    this.modalService.onHidden.subscribe(
      (reason: string) => {
        this.triggerElement.focus();
      },
      (err) => {
        this.loggingService.log('Caught Error: ' + err);
      }
    );
  }
}
